import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '@environments/environment';
import { PollDataService, TrackingService } from '@services/index';
import { AuthService } from '@examsoft/es-login';

@Component({
  selector: 'app-poll-launcher',
  templateUrl: './poll-launcher.component.html',
  styleUrls: ['./poll-launcher.component.scss']
})
export class PollLauncherComponent {
  error = '';
  username = '';
  esId = '';
  activeSubscription: any;
  statusPrompt = 'WaitingForAssessment';

  constructor(
    private router: Router,
    private trackingService: TrackingService,
    private pollDataService: PollDataService,
    private authService: AuthService,
  ) {
    this.esId = this.authService.user['custom:es-id'];
  }

  ngOnInit() {
    this.pollDataService.pollHistory.subscribe( data => {
      this.statusPrompt = data ? 'Completed' : 'WaitingForAssessment';
      this.trackingService.addPageAction('student-launcher-ready', { status: this.statusPrompt})
    });
    this.onActivePollUpdate();
    setTimeout( () => {
      this.getStudentPolls();
    }, 3000);
  }

  onActivePollUpdate() {
    if(this.activeSubscription && this.activeSubscription.unsubscribe) {
      this.activeSubscription.unsubscribe();
    }
    this.activeSubscription = this.pollDataService.getActivePollUpdates(this.esId)
    .subscribe({
      next: poll => this.handleActivePollUpdate(poll),
      error: err => {
        this.activeSubscription.unsubscribe();
        this.getStudentPolls();
        this.onActivePollUpdate();
      }
    });
  }

  handleActivePollUpdate(poll) {
    if (poll.pollId) {
      this.trackingService.addPageAction('student-active-subscription', { pollId: poll.pollId });
      this.goToPoll(poll.pollId);
    }
  }

  getStudentPolls(){
    this.pollDataService.getStudentPolls(this.esId)
      .then( polls => {
        if(polls.length){
          if(polls.length === 1){
            this.trackingService.addPageAction('student-launcher-single-poll', { pollId: polls[0].id })
            this.goToPoll(polls[0].id);
          }else{
            let ids = polls.map( poll => poll.id );
            this.trackingService.addPageAction('student-launcher-multiple-polls',{ pollIds: ids } );
            this.togglePollOptions(polls);
          }
        }
      });
  }


  popupOptions = [];
  displayPopup = false;
  togglePollOptions(polls){
    if(polls){
      this.popupOptions = polls
        .filter( poll => poll.portalPid && poll.title )
        .map( poll => { return { id: poll.id, caption: poll.portalPid, name: poll.title } });
      this.displayPopup = true;
    }else{
      this.popupOptions = [];
      this.displayPopup = false;
    }
  }

  goToPoll(pollId) {
    this.trackingService.addPageAction('student-launcher-redirect', { pollId: pollId })

    this.pollDataService.getPoll(pollId)
      .then(poll => { this.router.navigate([ 'poll', pollId]) })
      .catch(error => { this.error = error });
  }

  ngOnDestroy() {
    this.activeSubscription.unsubscribe();
    this.pollDataService.pollHistory.next(null);
  }
}
